import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Superheader.css"; // Ensure styles are defined
import ProgressLoader from "../Loader/ProgressLoader";

const Superheader = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [currentLineIndex, setCurrentLineIndex] = useState(0);

  // Fetch data from the API
  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_SuperHeader_Slogan"
      );
      console.log(response.data);
      setFetchedData(response.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (fetchedData.length > 0) {
      const interval = setInterval(() => {
        setCurrentLineIndex(
          (prevIndex) => (prevIndex + 1) % fetchedData.length
        );
      }, 2000);
      return () => clearInterval(interval);
    }
    return undefined;
  }, [fetchedData]);

  return (
    <div className="superheader-container d-flex justify-content-center align-items-center">
      {fetchedData.length > 0 ? (
        <p className="superheader-text">
          {fetchedData[currentLineIndex]?.name}&nbsp;
        </p>
      ) : (
        <p className="superheader-placeholder"><ProgressLoader /></p>
      )}
    </div>
  );
};

export default Superheader;
